import { styled } from '@mui/system';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, IconButton } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const StyledDatePicker = styled(DatePicker)`
  .MuiOutlinedInput-root {
    background-color: ${customPalette.accent.white};
    border-radius: 8px;

    &.Mui-disabled {
      background-color: ${customPalette.grey[50]};

      .MuiOutlinedInput-notchedOutline {
        border-color: ${customPalette.grey[100]};
      }

      .MuiSvgIcon-root {
        color: ${customPalette.grey[300]};
      }

      &:hover {
        .MuiOutlinedInput-notchedOutline {
          border-color: ${customPalette.grey[100]};
        }
      }
    }

    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${({ disabled }) =>
          disabled ? customPalette.grey[100] : customPalette.blue.main};
      }
    }

    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${customPalette.blue.main};
        border-width: 2px;
      }
    }

    &.Mui-error {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${customPalette.negative[600]};
      }
    }
  }

  .MuiInputLabel-root.Mui-disabled {
    color: ${customPalette.grey[300]};
  }

  input:disabled {
    color: ${customPalette.grey[400]};
    -webkit-text-fill-color: ${customPalette.grey[400]};
  }

  .MuiPickersDay-root {
    &.Mui-selected {
      background-color: ${customPalette.blue.main};

      &:hover {
        background-color: ${customPalette.blue.main};
      }
    }

    &.Mui-disabled {
      color: ${customPalette.grey[300]};
    }
  }

  .MuiInputLabel-root {
    &.Mui-focused {
      color: ${customPalette.blue.main};
    }
  }

  .MuiPickersCalendarHeader-root {
    color: ${customPalette.blue.main};
  }

  .MuiPickersDay-today {
    border-color: ${customPalette.blue.main};
  }
`;

export const PickersContainer = styled(Box)`
  display: flex;
  gap: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const DatePickerWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const ErrorText = styled('p')`
  color: ${customPalette.negative[600]};
  margin: 4px 0 0;
  font-size: 0.75rem;
`;

export const StyledClearButton = styled(IconButton)`
  color: ${customPalette.negative[600]};
  padding: 8px;
  height: fit-content;

  &:hover {
    background-color: ${customPalette.negative[100]};
  }
`;

export const DatePickersBox = styled(Box)`
  display: flex;
  gap: 16px;
  flex: 1;
`;

export const TranslationModeSpan = styled('span')`
  background: ${customPalette.positive[200]};
  color: black;
  padding: 8px;
  cursor: pointer;
  height: fit-content;
  margin-top: 8px;
`;
